import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../../_helpers/Helpers";
import * as actions from "../../../../../_redux/private-notices/PrivateNoticesAction";
import { useParentsUIContext } from "../ParentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { name, surname, student, sectionId, phone, email } = values;
  const noticeId = queryParams.filter.noticeId;
  const newQueryParams = { ...queryParams };
  const filter = { noticeId, name, surname, student, sectionId, phone, email };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function ParentsFilter() {
  // Parents UI Context
  const parentsUIContext = useParentsUIContext();
  const parentsUIProps = useMemo(() => {
    return {
      setQueryParams: parentsUIContext.setQueryParams,
      queryParams: parentsUIContext.queryParams,
    };
  }, [parentsUIContext]);

  const dispatch = useDispatch();
  const { sections } = useSelector(
    (state) => ({
      sections: state.privateNotices.filterList
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getSections());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(parentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, parentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      parentsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const sectionOptions = FilterOptions.concat(sections);

  return (
    <Formik
      initialValues={{        
        name: "",
        surname: "",
        student: "",
        phone: "",
        email: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="student"
                placeholder="Öğrenci"
                onBlur={handleBlur}
                value={values.student}
                onChange={(e) => {
                  setFieldValue("student", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sectionOptions}
                value={values.sectionId}
                placeholder="Şube"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sectionId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="phone"
                placeholder="Telefon"
                onBlur={handleBlur}
                value={values.phone}
                onChange={(e) => {
                  setFieldValue("phone", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Telefon</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="email"
                placeholder="Email"
                onBlur={handleBlur}
                value={values.email}
                onChange={(e) => {
                  setFieldValue("email", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Email</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}